/* Saved products: a star on product pages, a "Saved products" link in the menu and header, and the saved page.
   Saved products live in this browser (localStorage), so no account is needed.
   Also: recommended products in the cart, and the photo thumbnails, features, sale highlight and
   "Email me when available" in the quick view. */
(function () {
  'use strict';

  var KEY = 'mirrorless.saved.v1';
  var SAVED_URL = '/pages/saved';
  var memory = null;

  // The four-point star used across the site
  var STAR_PATH = 'M12 0C13 8 16 11 24 12C16 13 13 16 12 24C11 16 8 13 0 12C8 11 11 8 12 0Z';
  var STAR = '<svg class="save-star" viewBox="-2 -2 28 28" width="20" height="20" aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '" stroke-width="1.8" stroke-linejoin="round"/></svg>';

  // ---------- storage ----------
  function readStore() {
    if (memory) return memory.slice();
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (x) { return x && x.h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      memory = null;
    } catch (e) {
      memory = list.slice();
    }
    document.dispatchEvent(new CustomEvent('saved:change'));
  }

  function indexOf(list, handle) {
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return i;
    return -1;
  }

  var api = {
    list: function () {
      return readStore().sort(function (a, b) { return (b.ts || 0) - (a.ts || 0); });
    },
    has: function (handle) { return indexOf(readStore(), handle) > -1; },
    count: function () { return readStore().length; },
    add: function (entry) {
      var list = readStore();
      var i = indexOf(list, entry.h);
      if (i > -1) {
        list[i] = Object.assign({}, list[i], entry);
      } else {
        entry.ts = Date.now();
        list.push(entry);
      }
      writeStore(list);
    },
    remove: function (handle) {
      writeStore(readStore().filter(function (x) { return x.h !== handle; }));
    }
  };
  window.MirrorlessSaved = api;

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) document.dispatchEvent(new CustomEvent('saved:change'));
  });

  // ---------- helpers ----------
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function activeCurrency() {
    try { return window.Shopify.currency.active || 'USD'; } catch (e) { return 'USD'; }
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency() }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // "$61" for whole amounts, "$61.50" otherwise (like the product page's savings pill)
  function moneyShort(amount) {
    var whole = Math.abs(amount - Math.round(amount)) < 0.005;
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency(),
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(amount);
    } catch (e) {
      return '$' + (whole ? Math.round(amount) : amount.toFixed(2));
    }
  }

  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  // Resolves to the product, null if the store says it no longer exists, or false if the request just failed
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.status === 404 ? null : false;
      })
      .catch(function () { return false; });
  }

  function entryFrom(product) {
    return {
      h: product.handle,
      t: product.title,
      i: product.featured_image || '',
      p: product.price,
      c: product.compare_at_price || 0,
      a: !!product.available
    };
  }

  // ---------- toast ----------
  var toastTimer = null;

  function toast(message, withLink) {
    var node = document.getElementById('saved-toast');
    if (!node) {
      node = el('div');
      node.id = 'saved-toast';
      node.className = 'saved-toast';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      document.body.appendChild(node);
    }
    node.innerHTML = '';
    node.appendChild(el('span', 'saved-toast__text', message));
    if (withLink) {
      var a = el('a', 'saved-toast__link', 'View saved');
      a.href = SAVED_URL;
      node.appendChild(a);
    }
    node.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { node.classList.remove('is-visible'); }, 3200);
  }

  // ---------- star on product pages ----------
  function productHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function initProductButton() {
    var handle = productHandle();
    var info = document.querySelector('.product-info');
    if (!handle || !info || info.querySelector('.save-btn')) return;

    var btn = el('button', 'save-btn');
    btn.type = 'button';
    btn.innerHTML = STAR;
    var label = el('span', 'sr-only');
    btn.appendChild(label);

    var spinTimer = null;

    function sync() {
      var on = api.has(handle);
      btn.classList.toggle('is-saved', on);
      btn.setAttribute('aria-pressed', String(on));
      btn.title = on ? 'Saved. Tap to remove' : 'Save for later';
      label.textContent = on ? 'Remove from saved products' : 'Save this product';
    }

    // Saving turns the star gold and gives it one full spin that ends upright
    function spin() {
      btn.classList.remove('is-spinning');
      void btn.offsetWidth; // restart the animation if it is already running
      btn.classList.add('is-spinning');
      clearTimeout(spinTimer);
      spinTimer = setTimeout(function () { btn.classList.remove('is-spinning'); }, 800);
    }

    btn.addEventListener('click', function () {
      if (api.has(handle)) {
        api.remove(handle);
        toast('Removed from saved');
        return;
      }
      var titleNode = document.querySelector('.product-info .product-title, .product-info h1, .product-info h2');
      api.add({ h: handle, t: titleNode ? titleNode.textContent.trim() : handle });
      spin();
      toast('Saved for later', true);
      fetchProduct(handle).then(function (product) {
        if (product && api.has(handle)) api.add(entryFrom(product));
      });
    });

    info.appendChild(btn);
    sync();
    document.addEventListener('saved:change', sync);
  }

  // ---------- header star + menu link ----------
  function updateIndicators() {
    var on = api.count() > 0;
    document.querySelectorAll('.header__saved-link, .saved-sidebar-link').forEach(function (n) {
      n.classList.toggle('has-saved', on);
    });
  }

  function initNavLinks() {
    // Desktop header: a star between the account and search icons
    var nav = document.querySelector('.header__secondary-nav ul');
    if (nav && !nav.querySelector('.header__saved-link')) {
      var li = el('li', 'header__saved-link sm-max:hidden');
      var a = el('a');
      a.href = SAVED_URL;
      a.innerHTML = '<span class="sr-only">Saved products</span>' +
        '<svg class="header__nav-icon save-star" viewBox="-2 -2 28 28" width="22" height="22" aria-hidden="true" focusable="false"><path d="' + STAR_PATH + '" stroke-width="1.6" stroke-linejoin="round"/></svg>';
      li.appendChild(a);
      var anchor = nav.querySelector('.header__account-link') || nav.querySelector('.header__search-link');
      if (anchor) nav.insertBefore(li, anchor);
      else nav.appendChild(li);
    }

    // Phone menu: "Saved products" just above Login
    var footer = document.querySelector('.header-sidebar__footer');
    if (footer && !footer.querySelector('.saved-sidebar-link')) {
      var link = el('a', 'saved-sidebar-link text-with-icon smallcaps sm:hidden');
      link.href = SAVED_URL;
      link.innerHTML = STAR + 'Saved products';
      var account = footer.querySelector('a[href*="account"]');
      if (account) footer.insertBefore(link, account);
      else footer.insertBefore(link, footer.firstChild);
    }

    updateIndicators();
  }

  document.addEventListener('saved:change', updateIndicators);

  // ---------- saved page ----------
  function initSavedPage() {
    var grid = document.querySelector('[data-saved-grid]');
    if (!grid || grid.__ready) return;
    grid.__ready = true;
    var empty = document.querySelector('[data-saved-empty]');
    var count = document.querySelector('[data-saved-count]');
    var cards = {};

    function priceNode(entry) {
      var wrap = el('span', 'saved-card__price');
      if (entry.p != null) {
        if (entry.c && entry.c > entry.p) {
          wrap.appendChild(el('s', 'saved-card__was', money(entry.c)));
          wrap.appendChild(el('span', 'saved-card__now', money(entry.p)));
        } else {
          wrap.appendChild(el('span', 'saved-card__now', money(entry.p)));
        }
      }
      return wrap;
    }

    function signature(entry) {
      return [entry.t, entry.i, entry.p, entry.c, entry.a].join('|');
    }

    function buildCard(entry) {
      var card = el('article', 'saved-card');
      card.setAttribute('data-handle', entry.h);
      card.__sig = signature(entry);

      var link = el('a', 'saved-card__link');
      link.href = '/products/' + encodeURIComponent(entry.h);

      var media = el('span', 'saved-card__media');
      if (entry.i) {
        var img = el('img');
        img.src = sizedImage(entry.i, 600);
        img.alt = '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      link.appendChild(media);
      link.appendChild(el('span', 'saved-card__title', entry.t || entry.h));
      link.appendChild(priceNode(entry));
      card.appendChild(link);

      if (entry.a === false) card.appendChild(el('span', 'saved-card__badge', 'Sold out'));

      var remove = el('button', 'saved-card__remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + (entry.t || 'this product') + ' from saved products');
      remove.innerHTML = STAR;
      remove.addEventListener('click', function () { api.remove(entry.h); });
      card.appendChild(remove);

      return card;
    }

    function render() {
      var list = api.list();
      var handles = list.map(function (x) { return x.h; });

      Object.keys(cards).forEach(function (h) {
        if (handles.indexOf(h) === -1) {
          if (cards[h].parentNode) cards[h].parentNode.removeChild(cards[h]);
          delete cards[h];
        }
      });

      // Only cards whose details changed are rebuilt, so photos don't reload every time something is removed
      list.forEach(function (entry) {
        var existing = cards[entry.h];
        if (existing && existing.__sig === signature(entry)) return;
        var fresh = buildCard(entry);
        if (existing && existing.parentNode) existing.parentNode.replaceChild(fresh, existing);
        else grid.appendChild(fresh);
        cards[entry.h] = fresh;
      });

      // Newest saved first
      list.forEach(function (entry) { grid.appendChild(cards[entry.h]); });

      if (empty) empty.hidden = list.length > 0;
      grid.hidden = list.length === 0;
      if (count) {
        count.textContent = list.length ? list.length + (list.length === 1 ? ' product' : ' products') : '';
      }
    }

    // Show what was saved straight away, then refresh price, photo and stock from the store
    render();
    api.list().forEach(function (entry) {
      fetchProduct(entry.h).then(function (product) {
        if (product === null) {
          api.remove(entry.h); // the product no longer exists
          return;
        }
        if (!product) return; // request failed: keep what we have
        var next = entryFrom(product);
        var same = entry.t === next.t && entry.i === next.i && entry.p === next.p && entry.c === next.c && entry.a === next.a;
        if (!same && api.has(entry.h)) api.add(next);
      });
    });

    document.addEventListener('saved:change', render);
  }

  // ---------- recommended products in the cart (dropdown + cart page) ----------
  // The cart draws an empty holder with the address of Shopify's recommendations for the newest item in the cart.
  // The section at that address (sections/cart-recommendations.liquid) returns the product cards.
  var recsCache = {};

  function loadRecs(node) {
    if (node.getAttribute('data-recs-state')) return;
    var url = node.getAttribute('data-url');
    if (!url) return;
    node.setAttribute('data-recs-state', 'loading');

    var request = recsCache[url] || (recsCache[url] = fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; }));

    request.then(function (html) {
      var doc = new DOMParser().parseFromString(html || '', 'text/html');
      var inner = doc.querySelector('.cart-recs__inner');
      if (inner && node.isConnected) node.innerHTML = inner.outerHTML;
      node.setAttribute('data-recs-state', 'done');
    });
  }

  // ---------- quick view ----------
  function priceNumber(node) {
    if (!node) return 0;
    var n = parseFloat((node.textContent || '').replace(/[^0-9.]/g, ''));
    return isNaN(n) ? 0 : n;
  }

  function quickViewHandle(modal) {
    var handle = (modal.getAttribute('handle') || '').split('?')[0];
    if (!handle) {
      var t = modal.querySelector('.product-title a');
      handle = t ? t.getAttribute('href').split('?')[0].replace(/^\/products\//, '') : '';
    }
    return handle;
  }

  // The sale highlight (the red "Save $61 / 38% off" pill from the product page) for the selected size
  function updateQuickViewSale(modal) {
    var list = modal.querySelector('.product-info__block-list');
    if (!list) return;
    var sale = modal.querySelector('sale-price');
    var was = modal.querySelector('compare-at-price');
    var now = priceNumber(sale);
    var before = priceNumber(was);

    var holder = list.querySelector('.qb-sale-item');
    if (!(before > now && now > 0)) {
      if (holder) holder.remove();
      return;
    }

    var saved = before - now;
    var percent = Math.round(saved * 100 / before);

    if (!holder) {
      holder = el('div', 'product-info__block-item qb-sale-item');
      var picker = list.querySelector('.product-info__block-item[data-block-type="variant-picker"]');
      if (picker) list.insertBefore(holder, picker);
      else list.appendChild(holder);
    }

    var pill = holder.querySelector('.cleats-savings');
    if (!pill) {
      pill = el('p', 'cleats-savings');
      pill.appendChild(el('strong'));
      pill.appendChild(el('span'));
      holder.appendChild(pill);
    }
    var text = 'Save ' + moneyShort(saved);
    var pct = percent + '% off';
    if (pill.firstChild.textContent !== text) pill.firstChild.textContent = text;
    if (pill.lastChild.textContent !== pct) pill.lastChild.textContent = pct;
  }

  // Brief features and materials (from the quick-features section) under the reviews and sale highlight
  var featuresCache = {};

  function updateQuickViewFeatures(modal) {
    var wrapper = modal.querySelector('.quick-buy-modal__gallery-wrapper');
    var handle = quickViewHandle(modal);
    if (!wrapper || !handle) return;

    var cached = featuresCache[handle];
    if (cached === undefined) {
      featuresCache[handle] = null; // loading
      fetch('/products/' + encodeURIComponent(handle) + '?section_id=quick-features')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var inner = doc.querySelector('.qb-features__inner');
          featuresCache[handle] = inner ? inner.outerHTML : '';
          scan();
        })
        .catch(function () { featuresCache[handle] = ''; });
      return;
    }
    if (!cached || wrapper.querySelector('.qb-features')) return;

    var box = el('div', 'qb-features');
    box.innerHTML = cached;
    wrapper.appendChild(box);
  }

  // Little photo icons under the photo (shown on phones): tap one to jump to that photo; swiping the photo still works
  function updateQuickViewThumbs(modal) {
    var gallery = modal.querySelector('product-gallery');
    var carousel = gallery && gallery.querySelector('scroll-carousel');
    if (!gallery || !carousel || gallery.querySelector('.qb-thumbs')) return;

    var cells = Array.prototype.slice.call(carousel.children).filter(function (c) { return c.querySelector('img'); });
    if (cells.length < 2) return;

    function step() {
      return (cells[1].offsetLeft - cells[0].offsetLeft) || carousel.clientWidth || 1;
    }

    var wrap = el('div', 'qb-thumbs');
    var buttons = cells.map(function (cell, i) {
      var src = cell.querySelector('img').getAttribute('src') || '';
      var b = el('button', 'qb-thumb');
      b.type = 'button';
      b.setAttribute('aria-label', 'Show photo ' + (i + 1));
      var im = el('img');
      im.alt = '';
      im.loading = 'lazy';
      im.src = src.replace(/width=\d+/, 'width=120');
      b.appendChild(im);
      b.addEventListener('click', function () {
        carousel.scrollTo({ left: i * step(), behavior: 'smooth' });
      });
      wrap.appendChild(b);
      return b;
    });

    function sync() {
      var i = Math.max(0, Math.min(cells.length - 1, Math.round(carousel.scrollLeft / step())));
      buttons.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
    }

    carousel.addEventListener('scroll', sync, { passive: true });
    gallery.appendChild(wrap);
    sync();
  }

  // "Email me when available" when the selected size is sold out. The link opens the product page on that size
  // with #notify, and the product page then opens the back-in-stock sign-up for it (see initNotifyFromLink).
  function updateQuickView() {
    document.querySelectorAll('quick-buy-modal').forEach(function (modal) {
      updateQuickViewSale(modal);
      updateQuickViewThumbs(modal);
      updateQuickViewFeatures(modal);

      var bb = modal.querySelector('buy-buttons');
      if (!bb) return;
      var block = bb.closest('.product-info__block-item') || bb.parentElement;
      if (!block) return;

      var button = bb.querySelector('button.button, button[type="submit"]');
      var soldOut = !!(button && button.disabled && /sold\s*out/i.test(button.textContent));

      var link = block.querySelector('.qb-notify');
      if (!link) {
        link = el('a', 'qb-notify', 'Email me when available');
        block.appendChild(link);
      }

      if (soldOut) {
        var form = document.getElementById(bb.getAttribute('form'));
        var idInput = form && form.querySelector('[name="id"]');
        link.href = '/products/' + quickViewHandle(modal) + (idInput && idInput.value ? '?variant=' + idInput.value : '') + '#notify';
      }
      link.hidden = !soldOut;
    });
  }

  var notifyDone = false;
  function initNotifyFromLink() {
    if (notifyDone || location.hash !== '#notify') return;
    notifyDone = true;
    var tries = 0;
    (function look() {
      var b = document.querySelector('.product-info .gBackInStock-Button button, .product-info .gBackInStockBtn');
      if (b && b.offsetParent !== null) {
        b.click();
        return;
      }
      if (++tries < 40) setTimeout(look, 300);
    })();
  }

  var scanQueued = false;
  function scan() {
    if (scanQueued) return;
    scanQueued = true;
    setTimeout(function () {
      scanQueued = false;
      document.querySelectorAll('[data-cart-recs]').forEach(loadRecs);
      updateQuickView();
    }, 30);
  }

  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });

  // ---------- start ----------
  function start() {
    initNavLinks();
    initProductButton();
    initSavedPage();
    initNotifyFromLink();
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('pageshow', start);
})();